export default (theme) => ({
  availabilitySelector: {
    marginTop: 20,
    padding: 10,
    border: `1px solid ${theme.palette.disabled.main}`,
    borderRadius: 5,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    color: 'grey',
    '& span': {
      fontSize: 12,
      [theme.breakpoints.down('xl')]: {
        fontSize: 10,
      },
    },
    '& label': {
      marginRight: 5,
      marginLeft: 5,
    },
    '& svg': {
      width: 30,
      height: 30,
    },
    '& .MuiCheckbox-root': {
      [theme.breakpoints.down('xl')]: {
        padding: 6,
      },
      [theme.breakpoints.down('lg')]: {
        padding: 0,
      },
    },
    [theme.breakpoints.down('md')]: {
      padding: 0,
      border: 'none',
      flexDirection: 'row',
    },
  },
  availabilitySelectorGroup: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  checkboxes: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 7,
    '&:first-of-type': {
      marginTop: 0,
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      marginTop: 0,
    },
  },
  groupLabel: {
    marginRight: 20,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      margin: '0 4px 20px 4px',
    },
  },
  labels: {
    color: 'grey',
    display: 'flex',
    justifyContent: 'flex-end',
    '& span': {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 30,
      margin: '0 28px 0 0',
      [theme.breakpoints.down('xl')]: {
        margin: '0 22px 0 0',
      },
      [theme.breakpoints.down('lg')]: {
        margin: '0 10px 0 0',
      },
      [theme.breakpoints.down('md')]: {
        margin: '0 0 15px 0',
      },
      '&:last-of-type': {
        marginRight: 15,
        [theme.breakpoints.down('xl')]: {
          marginRight: 11,
        },
        [theme.breakpoints.down('lg')]: {
          marginRight: 5,
        },
        [theme.breakpoints.down('md')]: {
          margin: '0 0 8px 0',
        },
      },
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      color: 'grey',
    },
  },
  icon: {
    marginRight: 15,
    objectFit: 'contain',
    objectPosition: 'bottom',
    '& svg': {
      width: 25,
      height: 25,
      '&:last-child': {
        width: 20,
        height: 20,
      },
    },
    '& svg path': {
      fill: theme.palette.font.main,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
      '& svg': {
        width: 20,
        height: 20,
        '&:last-child': {
          width: 15,
          height: 15,
        },
      },
    },
  },
  timeInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    color: 'grey',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      alignItems: 'center',
      marginTop: 10,
      '& span': {
        fontSize: 11,
      },
      '& span:last-of-type': {
        fontSize: 8,
      },
    },
  },
  input: {
    [theme.breakpoints.down('md')]: {
      padding: 5,
    },
  },
});
